<div *ngIf="!isSigFinish" class="allContent">
  <app-ivpad [ngClass]="{ isDisabled: verifyPressure && !deviceAllowed }" #ivpad [startOpened]="true" [opened]="true"
    [isModal]="true" [showButtons]="false" [signingEnabled]="false" cdkFocusInitial></app-ivpad>
  <div class="buttons" style="display: flex; justify-content: center;" mat-dialog-actions>
    <signaturit-button text="{{labelClean}}" type="tertiary" size="md" (click)="clearSign()"></signaturit-button>
    <signaturit-button class="btn" text="{{labelSign}}" type="primary" size="md" (click)="sign()" [disabled]="verifyPressure && !deviceAllowed"></signaturit-button>
  </div>
  <div *ngIf="biometry" class="biometryContainer">
    <div *ngIf="!verifyPressure && !deviceAllowed && !mobile" class="info advise" id="messageContainer">
      <mat-icon class="icon help">help</mat-icon>
      <p class="mb-0" id="info">{{'finish_sigbio_custom_01' | translate:_transParam}}</p>
    </div>
    <div *ngIf="verifyPressure && !deviceAllowed && !mobile" class="info advise" id="messageContainer">
      <mat-icon class="icon cancel">cancel</mat-icon>
      <p class="mb-0" id="info">{{'finish_sigbio_custom_02' | translate:_transParam}}</p>
    </div>
  </div>
</div>

<div *ngIf="isSigFinish" class="message__success">
  <mat-icon>check_circle</mat-icon>
  <h2>{{'signaturit_pro.webSocket.continue_proccess' | translate:_transParam }}</h2>
  <p>{{'signaturit_pro.webSocket.success_message' | translate:_transParam }}</p>
</div>
